(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2369],{

/***/ 62253:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* binding */ ExternalLinkIcon; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/external-link.svg
var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgExternalLink = function SvgExternalLink(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 12 12"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    "data-name": "group2691"
  }, /*#__PURE__*/react.createElement("path", {
    "data-name": "rectangle139",
    d: "M3 1v8h8V1H3M2 0h10v10H2Z"
  }), /*#__PURE__*/react.createElement("path", {
    "data-name": "path293",
    d: "M7.83 12H0V4.245h1V11h6.83Z"
  }))));
};
/* harmony default export */ var external_link = (SvgExternalLink);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx


var _excluded = ["size"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }





var ExternalLinkIcon = function ExternalLinkIcon(_ref) {
  var size = _ref.size,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledIcon, _objectSpread({
    "aria-label": "\u65B0\u898F\u30BF\u30D6\u3067\u958B\u304F",
    size: size
  }, props));
};
var StyledIcon = (0,styled_components_browser_esm/* default */.ZP)(external_link).withConfig({
  displayName: "ExternalLink__StyledIcon",
  componentId: "sc-12ugb1p-0"
})(["transition:fill 0.3s ease-out;fill:", ";width:", ";height:", ";@media screen and (max-width:1047px){width:12px;height:12px;}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, function (_ref2) {
  var size = _ref2.size;
  return size === 'small' ? '12px' : '16px';
}, function (_ref3) {
  var size = _ref3.size;
  return size === 'small' ? '12px' : '16px';
});

/***/ }),

/***/ 53300:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "k": function() { return /* binding */ LinkCard; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react-scroll/modules/index.js
var modules = __webpack_require__(66261);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
// EXTERNAL MODULE: ./src/components/elements/Icon/ExternalLink/index.tsx + 1 modules
var ExternalLink = __webpack_require__(62253);
// EXTERNAL MODULE: ./src/components/elements/RoundedLabel/index.tsx
var RoundedLabel = __webpack_require__(51342);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/Card.tsx






var Card = function Card(_ref) {
  var imgPath = _ref.imgPath,
      title = _ref.title,
      detail = _ref.detail,
      isExternalLink = _ref.isExternalLink;
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Wrapper, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(Grid, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(ImageWrapper, {
        children: /*#__PURE__*/(0,jsx_runtime.jsx)("img", {
          src: imgPath,
          width: "100%",
          alt: ""
        })
      }), title && /*#__PURE__*/(0,jsx_runtime.jsx)(Title, {
        children: title
      })]
    }), detail && /*#__PURE__*/(0,jsx_runtime.jsx)(Detail, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("span", {
          children: detail
        }), isExternalLink && /*#__PURE__*/(0,jsx_runtime.jsx)(StyledExternalLinkIcon, {
          size: "small"
        })]
      })
    })]
  });
};
var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Wrapper",
  componentId: "sc-1z091jq-0"
})(["width:316px;height:100%;background:", ";border-radius:8px;display:flex;flex-direction:column;@media screen and (max-width:1047px){width:100%;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var Grid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Grid",
  componentId: "sc-1z091jq-1"
})(["display:grid;grid-template-columns:20px 1fr 20px;grid-template-rows:1fr auto 17px;@media screen and (max-width:1047px){grid-template-rows:1fr auto 17px;}"]);
var ImageWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__ImageWrapper",
  componentId: "sc-1z091jq-2"
})(["display:flex;justify-content:center;grid-area:1 / 1 / 4 / 4;height:188px;transition:opacity 0.25s ease;@media screen and (max-width:1047px){height:199px;}"]);
var Title = (0,styled_components_browser_esm/* default */.ZP)(RoundedLabel/* RoundedLabel */.I).withConfig({
  displayName: "Card__Title",
  componentId: "sc-1z091jq-3"
})(["grid-area:2 / 2 / 3 / 3;"]);
var Detail = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Card__Detail",
  componentId: "sc-1z091jq-4"
})(["background:#fff;padding:18px 26px 22px;border-width:0 4px 4px 4px;border-color:", ";border-style:solid;border-radius:0 0 8px 8px;line-height:1.4;letter-spacing:0.08em;flex:1;@media screen and (max-width:1047px){padding:13px 18px 16px;font-size:14px;}"], theme/* theme.colors.backgroundPaleBlue */.r.colors.backgroundPaleBlue);
var StyledExternalLinkIcon = (0,styled_components_browser_esm/* default */.ZP)(ExternalLink/* ExternalLinkIcon */.h).withConfig({
  displayName: "Card__StyledExternalLinkIcon",
  componentId: "sc-1z091jq-5"
})(["margin-left:8px;"]);
;// CONCATENATED MODULE: ./src/components/elements/LinkCard/index.tsx


var _excluded = ["link", "isExternalLink", "isScroll", "newWindow", "forceReload"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }







var LinkCard = function LinkCard(_ref) {
  var link = _ref.link,
      isExternalLink = _ref.isExternalLink,
      isScroll = _ref.isScroll,
      newWindow = _ref.newWindow,
      forceReload = _ref.forceReload,
      props = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  if (link) {
    if (isExternalLink) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
        href: link,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread(_objectSpread({}, props), {}, {
          isExternalLink: isExternalLink
        }))
      });
    }

    if (isScroll) {
      return /*#__PURE__*/(0,jsx_runtime.jsx)(StyledScroll, {
        to: link,
        smooth: true,
        duration: 600,
        children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
      });
    }

    var cardLink = /*#__PURE__*/(0,jsx_runtime.jsx)(StyledLink, {
      href: forceReload ? link : undefined,
      target: newWindow ? '_blank' : undefined,
      rel: newWindow ? 'noopener noreferrer' : undefined,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
    });

    if (forceReload) return cardLink;
    return /*#__PURE__*/(0,jsx_runtime.jsx)((link_default()), {
      href: link,
      passHref: true,
      children: cardLink
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(Card, _objectSpread({}, props))
  });
};
var LinkStyle = (0,styled_components_browser_esm/* css */.iv)(["display:block;width:316px;white-space:pre-wrap;&:hover > div > div:first-of-type{> div > img{opacity:0.6;transition:opacity 0.25s ease;}> div:nth-of-type(2){background:", ";transition:background 0.25s ease;}}@media screen and (max-width:1047px){width:335px;}"], theme/* theme.colors.hoverLightBlue */.r.colors.hoverLightBlue);
var StyledLink = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
  displayName: "LinkCard__StyledLink",
  componentId: "sc-1q4bvyj-0"
})(["", ""], LinkStyle);
var StyledScroll = (0,styled_components_browser_esm/* default */.ZP)(modules/* Link */.rU).withConfig({
  displayName: "LinkCard__StyledScroll",
  componentId: "sc-1q4bvyj-1"
})(["", ""], LinkStyle);

/***/ }),

/***/ 51342:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ RoundedLabel; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var RoundedLabel = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "RoundedLabel",
  componentId: "sc-1s4si24-0"
})(["color:#fff;background:", ";border-radius:23px;border:2px solid #fff;padding:12px 20px;font-size:17px;line-height:1.1;letter-spacing:0.04em;font-weight:700;word-break:break-all;text-align:center;position:relative;transition:background 0.25s ease;@media screen and (max-width:1047px){border-radius:25px;font-size:15px;padding:12px 50px;}"], _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue);

/***/ }),

/***/ 70770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N": function() { return /* binding */ SectionTitle; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var SectionTitle = function SectionTitle(_ref) {
  var titleText = _ref.titleText,
      subTitleText = _ref.subTitleText,
      enTitleText = _ref.enTitleText,
      color = _ref.color,
      _ref$as = _ref.as,
      as = _ref$as === void 0 ? 'h3' : _ref$as;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(SectionTitleDiv, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(TitleText, {
      color: color,
      as: as,
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(EnTitleText, {
      color: color,
      as: as,
      children: enTitleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(SubTitleText, {
      color: color,
      children: subTitleText
    })]
  });
};
var SectionTitleDiv = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "SectionTitle__SectionTitleDiv",
  componentId: "sc-17562y0-0"
})(["text-align:center;"]);
var TitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__TitleText",
  componentId: "sc-17562y0-1"
})(["font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";@media screen and (max-width:1047px){display:none;}"], function (_ref2) {
  var color = _ref2.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);
var SubTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].p.withConfig */ .ZP.p.withConfig({
  displayName: "SectionTitle__SubTitleText",
  componentId: "sc-17562y0-2"
})(["font-size:18px;line-height:26px;color:", ";@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref3) {
  var color = _ref3.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.overlay */ .r.colors.overlay) : "white";
});
var EnTitleText = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].h3.withConfig */ .ZP.h3.withConfig({
  displayName: "SectionTitle__EnTitleText",
  componentId: "sc-17562y0-3"
})(["@media screen and (min-width:1048px){font-weight:bold;font-size:42px;line-height:50px;margin-bottom:6px;color:", ";font-family:", ";}@media screen and (max-width:1047px){font-size:23px;line-height:1.2;font-weight:700;}"], function (_ref4) {
  var color = _ref4.color;
  return color === 'normal' ? "".concat(_styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.trialBlue */ .r.colors.trialBlue) : "white";
}, _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.fontEn */ .r.fontEn);

/***/ }),

/***/ 52143:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ CompanyLinks; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32125);
/* harmony import */ var _utils_routes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97749);
/* harmony import */ var _components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53300);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);




var CompanyLinks = function CompanyLinks(_ref) {
  var padding = _ref.padding;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviListWrapper, {
    padding: padding,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(CompanyNaviList, {
      children: _utils_routes__WEBPACK_IMPORTED_MODULE_0__/* .COMPANY_ROUTE.subdirectories.map */ .Ir.subdirectories.map(function (_ref2) {
        var path = _ref2.path,
            name = _ref2.name,
            imagePath = _ref2.imagePath;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("li", {
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_components_elements_LinkCard__WEBPACK_IMPORTED_MODULE_1__/* .LinkCard */ .k, {
            link: path,
            title: name,
            imgPath: imagePath
          })
        }, name);
      })
    })
  });
};
var CompanyNaviListWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
  displayName: "CompanyLinks__CompanyNaviListWrapper",
  componentId: "sc-106wc0z-0"
})(["margin:0 auto;padding:", ";width:1040px;@media screen and (max-width:1047px){padding:", ";width:100%;display:", ";}"], function (_ref3) {
  var padding = _ref3.padding;
  return padding.pc;
}, function (_ref4) {
  var padding = _ref4.padding;
  return padding.sp;
}, function (_ref5) {
  var padding = _ref5.padding;
  return !padding.sp && 'none';
});
var CompanyNaviList = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "CompanyLinks__CompanyNaviList",
  componentId: "sc-106wc0z-1"
})(["display:flex;flex-wrap:wrap;gap:66px 46px;@media screen and (max-width:1047px){justify-content:center;gap:38px;li:nth-child(odd):last-child{margin-right:388px;}}@media screen and (max-width:700px){li:nth-child(odd):last-child{margin-right:0;}}"]);

/***/ }),

/***/ 22978:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ Head; }
/* harmony export */ });
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Head = function Head(_ref) {
  var _ogp$image, _ogp$type;

  var title = _ref.title,
      _ref$hasTitleSuffix = _ref.hasTitleSuffix,
      hasTitleSuffix = _ref$hasTitleSuffix === void 0 ? true : _ref$hasTitleSuffix,
      description = _ref.description,
      noindex = _ref.noindex,
      ogp = _ref.ogp;
  var ogpImage = (_ogp$image = ogp === null || ogp === void 0 ? void 0 : ogp.image) !== null && _ogp$image !== void 0 ? _ogp$image : {
    src: 'https://trial-holdings.inc/images/ogp.png',
    width: 1200,
    height: 630
  };
  var titleText = hasTitleSuffix ? "".concat(title, " | \u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9") : title;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("title", {
      children: titleText
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "description",
      content: description
    }), noindex && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
      name: "robots",
      content: "noindex, nofollow"
    }), ogp && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:type",
        content: (_ogp$type = ogp.type) !== null && _ogp$type !== void 0 ? _ogp$type : 'website'
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:url",
        content: "https://trial-holdings.inc/".concat(ogp.url)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:title",
        content: ogp.title || titleText
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:description",
        content: description
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image",
        content: ogpImage.src
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:width",
        content: "".concat(ogpImage.width)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:image:height",
        content: "".concat(ogpImage.height)
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:site_name",
        content: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("meta", {
        property: "og:locale",
        content: "ja_JP"
      })]
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("link", {
      rel: "icon",
      href: "/images/favicon.ico"
    })]
  });
};

/***/ }),

/***/ 61580:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ AccessPage; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/pages/Company/Access/CPMapList.tsx




var cpMapList = [{
  cpName: '本社',
  cpSubName: '株式会社トライアルホールディングス・株式会社トライアルカンパニー',
  cpAddress: '〒813-0034 　福岡市東区多の津1丁目12番2号',
  addressUrl: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3322.2118348495715!2d130.448264!3d33.625749!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xfe465403033e9c51!2z5qCq5byP5Lya56S-44OI44Op44Kk44Ki44Or44Kr44Oz44OR44OL44O8!5e0!3m2!1sja!2sjp!4v1637135606813!5m2!1sja!2sjp',
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 40,
        pc: 42
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      children: "[\u4EA4\u901A\u30A2\u30AF\u30BB\u30B9]"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 36,
        pc: 30
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
      children: "\u30D0\u30B9\u3092\u3054\u5229\u7528\u306E\u5834\u5408"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 15,
        pc: 12
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u535A\u591A\uFF08\u535A\u591A\u99C5\u30D0\u30B9\u30BF\u30FC\u30DF\u30CA\u30EB\uFF09\u3088\u308A\u300114\u756A\u4E57\u5834\u306773\u756A\u300C\u571F\u4E95\u55B6\u696D\u6240\u300D\u300C\u571F\u4E95\u56E3\u5730\u300D\u3082\u3057\u304F\u306F\u300C\u307F\u3069\u308A\u304C\u4E18\u56E3\u5730\u5165\u53E3\u300D\u884C\u306E\u30D0\u30B9\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002\u300C\u30AA\u30ED\u30B7\u30A2\u30E0FUKUOKA\uFF08\u65E7\u5378\u4F1A\u9928\u524D\uFF09\u300D\u3067\u4E0B\u8ECA\u3057\u3001\u5F92\u6B692\u30013\u5206"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 42,
        pc: 45
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
      children: "\u96FB\u8ECA\u3092\u3054\u5229\u7528\u306E\u5834\u5408"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 15,
        pc: 12
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("p", {
      children: ["JR\u7BB1\u5D0E\u99C5\u3092\u51FA\u3066\u7BB1\u5D0E\u99C5\u897F\u53E3\u30D0\u30B9\u505C\u7559\u6240\u3088\u308A\u300178\u756A\u300C\u571F\u4E95\u56E3\u5730\u300D\u3082\u3057\u304F\u306F\u300C\u307F\u3069\u308A\u304C\u4E18\u56E3\u5730\u5165\u53E3\u300D\u884C\u306E\u30D0\u30B9\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002\u300C\u30AA\u30ED\u30B7\u30A2\u30E0FUKUOKA\uFF08\u65E7\u5378\u4F1A\u9928\u524D\uFF09\u300D\u3067\u4E0B\u8ECA\u3057\u3001\u5F92\u6B692\u30013\u5206", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "JR\u5343\u65E9\u99C5\u3092\u51FA\u3066\u5343\u65E9\u99C5\u524D\u30D0\u30B9\u505C\u3088\u308A\u30013\u756A\u300C\u571F\u4E95\u55B6\u696D\u6240\u300D\u884C\u306E\u30D0\u30B9\u3092\u3054\u5229\u7528\u304F\u3060\u3055\u3044\u3002\u300C\u30AA\u30ED\u30B7\u30A2\u30E0FUKUOKA\uFF08\u65E7\u5378\u4F1A\u9928\u524D\uFF09\u300D\u3067\u4E0B\u8ECA\u3057\u3001\u5F92\u6B692\u30013\u5206"]
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 83
      }
    })]
  })
}, {
  cpName: '東京オフィス',
  cpSubName: '株式会社トライアルホールディングス・株式会社トライアルカンパニー',
  cpAddress: '〒108-0023 　東京都港区芝浦三丁目16番16号 住友不動産田町ビル東館 5F（総合受付）',
  addressUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3242.4283164152293!2d139.7465946762298!3d35.641817532137466!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x60188baedb024a65%3A0x47684ad20e4e676d!2sSumitomo%20Fudosan%20Tamachi%20Bldg.%20Higashikan!5e0!3m2!1szh-CN!2sjp!4v1773992257009!5m2!1sja!2sjp',
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 40,
        pc: 42
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      children: "[\u4EA4\u901A\u30A2\u30AF\u30BB\u30B9]"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 36,
        pc: 38
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "JR\u300C\u7530\u753A\u99C5\u300D\u829D\u6D66\u53E3\u3088\u308A\u5F92\u6B698\u5206"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u90FD\u55B6\u5730\u4E0B\u9244\u6D45\u8349\u7DDA\u30FB\u4E09\u7530\u7DDA\u300C\u4E09\u7530\u99C5\u300DA4\u51FA\u53E3\u3088\u308A\u5F92\u6B6910\u5206"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 83
      }
    })]
  })
}, {
  cpName: 'MUSUBU AI',
  cpAddress: '〒822-0133 　福岡県宮若市脇田394',
  addressUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3319.436704756755!2d130.58937415126087!3d33.697647080609194!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x35422b313d65e311%3A0x31f30c72bdb6e149!2sMUSUBU%20AI!5e0!3m2!1sja!2sjp!4v1675659119658!5m2!1sja!2sjp',
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 40,
        pc: 42
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      children: "[\u4EA4\u901A\u30A2\u30AF\u30BB\u30B9]"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 36,
        pc: 30
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
      children: "\u8ECA\u3092\u3054\u5229\u7528\u306E\u5834\u5408"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 15,
        pc: 12
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u798F\u5CA1\u7A7A\u6E2F\u3088\u308A\u8ECA\u3067\u7D0450\u5206"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 42,
        pc: 45
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
      children: "\u30D0\u30B9\u3092\u3054\u5229\u7528\u306E\u5834\u5408"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 15,
        pc: 12
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "JR\u4E5D\u5DDE\u30D0\u30B9\uFF1A\u535A\u591A\u30D0\u30B9\u30BF\u30FC\u30DF\u30CA\u30EB3\u968E33\u756A\u4E57\u308A\u5834\u3088\u308A\u5C71\u306E\u795E\u30FB\u76F4\u65B9\u884C\u304D\u300C\u5409\u5DDD\u6821\u524D\u300D\u4E0B\u8ECA\u5F92\u6B691\u5206"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 83
      }
    })]
  })
}, {
  cpName: 'TRIAL IoT Lab',
  cpAddress: '〒823-0013 　福岡県宮若市芹田9',
  addressUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3317.948164801104!2d130.63934125126173!3d33.73615648059844!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3543d51fc82207b7%3A0xcae303a2ae31b067!2sTRIAL%20IoT%20Lab!5e0!3m2!1sja!2sjp!4v1675659770154!5m2!1sja!2sjp',
  children: /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 40,
        pc: 42
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
      children: "[\u4EA4\u901A\u30A2\u30AF\u30BB\u30B9]"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 36,
        pc: 30
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
      children: "\u8ECA\u3092\u3054\u5229\u7528\u306E\u5834\u5408"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 15,
        pc: 12
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "\u798F\u5CA1\u7A7A\u6E2F\u3088\u308A\u8ECA\u3067\u7D0460\u5206"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 42,
        pc: 45
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("h5", {
      children: "\u30D0\u30B9\u3092\u3054\u5229\u7528\u306E\u5834\u5408"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 15,
        pc: 12
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
      children: "JR\u4E5D\u5DDE\u30D0\u30B9\uFF1A\u535A\u591A\u30D0\u30B9\u30BF\u30FC\u30DF\u30CA\u30EB3\u968E33\u756A\u4E57\u308A\u5834\u3088\u308A\u5C71\u306E\u795E\u30FB\u76F4\u65B9\u884C\u304D\u300C\u7B51\u524D\u82B9\u7530\u300D\u4E0B\u8ECA\u5F92\u6B695\u5206"
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 30,
        pc: 83
      }
    })]
  })
}];
// EXTERNAL MODULE: ./src/styles/theme.ts
var theme = __webpack_require__(49642);
;// CONCATENATED MODULE: ./src/components/pages/Company/Access/MapCard.tsx






var MapCard = function MapCard(_ref) {
  var cpName = _ref.cpName,
      cpSubName = _ref.cpSubName,
      cpAddress = _ref.cpAddress,
      addressUrl = _ref.addressUrl,
      children = _ref.children;
  return /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(AccessBody, {
      children: /*#__PURE__*/(0,jsx_runtime.jsxs)(AccessText, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(AccessCP, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)("h3", {
            children: cpName
          }), cpSubName && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
              h: {
                sp: 10,
                pc: 10
              }
            }), /*#__PURE__*/(0,jsx_runtime.jsx)("h4", {
              children: cpSubName
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 20,
              pc: 26
            }
          }), /*#__PURE__*/(0,jsx_runtime.jsx)("p", {
            children: cpAddress
          })]
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(StyleIframe, {
          src: addressUrl,
          allowFullScreen: true,
          loading: "lazy"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)(MapTextDiv, {
          children: children
        })]
      })
    })
  });
};
var AccessBody = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MapCard__AccessBody",
  componentId: "sc-169zzp7-0"
})(["width:1040px;border-radius:8px;background-color:", ";@media screen and (max-width:1047px){width:100%;}"], theme/* theme.colors.backgroundGrey */.r.colors.backgroundGrey);
var AccessText = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MapCard__AccessText",
  componentId: "sc-169zzp7-1"
})(["width:100%;padding:40px 90px 0px;display:flex;flex-direction:column;font-size:16px;color:", ";@media screen and (max-width:1047px){padding:30px 22px 0px;font-size:15px;}"], theme/* theme.colors.textTitle */.r.colors.textTitle);
var AccessCP = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MapCard__AccessCP",
  componentId: "sc-169zzp7-2"
})(["h3{font-size:30px;color:", ";font-weight:bold;line-height:1.2;}h4{font-size:18px;color:", ";font-weight:bold;line-height:1.2;}p{font-weight:500;line-height:1.6;}@media screen and (max-width:1047px){h3{font-size:20px;letter-spacing:2px;}h4{font-size:13px;}}"], theme/* theme.colors.trialBlue */.r.colors.trialBlue, theme/* theme.colors.trialBlue */.r.colors.trialBlue);
var StyleIframe = styled_components_browser_esm/* default.iframe.withConfig */.ZP.iframe.withConfig({
  displayName: "MapCard__StyleIframe",
  componentId: "sc-169zzp7-3"
})(["width:100%;height:500px;margin-top:42px;@media screen and (max-width:1047px){height:285px;margin-top:32px;}"]);
var MapTextDiv = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "MapCard__MapTextDiv",
  componentId: "sc-169zzp7-4"
})(["width:100%;font-size:16px;font-weight:bold;h4{font-size:18px;letter-spacing:1.8px;}h5{letter-spacing:0.96px;}p{font-weight:normal;letter-spacing:0.64px;line-height:29px;}@media screen and (max-width:1047px){font-size:15px;p{font-weight:400;letter-spacing:0.6px;line-height:25px;}}"]);
var ZenkakuSpace = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
  displayName: "MapCard__ZenkakuSpace",
  componentId: "sc-169zzp7-5"
})(["padding-left:", ";"], function (_ref2) {
  var space = _ref2.space;
  return space === undefined ? '1em' : "".concat(space, "em");
});
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/layout.tsx + 7 modules
var layout = __webpack_require__(55548);
// EXTERNAL MODULE: ./src/components/layouts/Company/CompanyLinks/index.tsx
var CompanyLinks = __webpack_require__(52143);
// EXTERNAL MODULE: ./src/components/layouts/Head/index.tsx
var Head = __webpack_require__(22978);
;// CONCATENATED MODULE: ./src/components/pages/Company/Access/index.tsx


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }













var sectionTitle = {
  titleText: 'Access',
  subTitleText: 'アクセス'
};
var AccessPage = function AccessPage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: sectionTitle.subTitleText,
      description: "\u30C8\u30E9\u30A4\u30A2\u30EB\u30DB\u30FC\u30EB\u30C7\u30A3\u30F3\u30B0\u30B9\u306E\u30AA\u30D5\u30A3\u30B9\u3078\u306E\u30A2\u30AF\u30BB\u30B9\u3092\u63B2\u8F09\u3057\u3066\u3044\u307E\u3059\u3002",
      ogp: {
        type: 'article',
        url: 'company/access/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(AccessContainer, {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 40,
          pc: 69
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
        color: "normal",
        titleText: sectionTitle.titleText,
        subTitleText: sectionTitle.subTitleText
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 58,
          pc: 129
        }
      }), cpMapList.map(function (value, index) {
        return /*#__PURE__*/(0,jsx_runtime.jsxs)(react.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(MapCard, _objectSpread({}, value)), index !== cpMapList.length - 1 && /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
            h: {
              sp: 41,
              pc: 76
            }
          })]
        }, value.addressUrl);
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(CompanyLinks/* CompanyLinks */.b, {
        padding: {
          pc: '130px 0 0'
        }
      })]
    })]
  });
};

AccessPage.getLayout = function getLayout(page) {
  var pageTitle = {
    title: 'Corporate Information',
    subTitle: '企業情報'
  };
  var breadCrumbs = [{
    name: 'ホーム',
    path: '/'
  }, {
    name: '企業情報',
    path: '/company/'
  }, {
    name: 'アクセス',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsx)(layout/* TitleLayout */.$0, _objectSpread(_objectSpread({}, pageTitle), {}, {
    breadCrumbs: breadCrumbs,
    isRequiredBackground: true,
    children: page
  }));
};

var AccessContainer = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
  displayName: "Access__AccessContainer",
  componentId: "sc-11pa9c1-0"
})(["width:1040px;padding-bottom:130px;margin:0 auto;@media screen and (max-width:1047px){width:100%;padding:0px 20px 75px;}"]);
;// CONCATENATED MODULE: ./src/pages/company/access.tsx


/***/ }),

/***/ 64776:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/company/access",
      function () {
        return __webpack_require__(61580);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,8517,5548,9774,2888,179], function() { return __webpack_exec__(64776); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);